export default __webpack_public_path__ + "static/media/0058.43c55224.png";